import React from "react";
import { IconChevronLeft } from "@tabler/icons-react";
import { AuthUtils } from "utils";
import { useFirstLogin } from "hooks";
import { SetAvatarForm, SetPasswordForm } from "./components";

const FirstLogin = () => {
  const {
    AVATAR_STEP,
    step,
    form,
    formMessage,
    handleChangePasswordForm,
    handleSubmitPasswordForm,
    handleChangeAvatarInput,
    handleSubmitImageForm,
    handleBackToPasswordForm,
  } = useFirstLogin();

  const handleClickBack = () => {
    if (step === AVATAR_STEP) handleBackToPasswordForm();
    else AuthUtils.handleLogout();
  };

  const isEnablePasswordSubmitButton = form.password && form.passwordConfirmation && !Boolean(formMessage.password);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--tblr-bg-surface-secondary)",
      }}
    >
      <div
        style={{
          maxWidth: "100vw",
          width: 830,
          backgroundColor: "var(--tblr-bg-surface)",
          borderRadius: 4,
          padding: "8px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        }}
      >
        <div
          className="d-inline-flex align-items-center"
          style={{ cursor: "pointer" }}
          onClick={handleClickBack}
        >
          <button className="btn btn-icon btn-ghost-secondary btn-sm">
            <IconChevronLeft size={16} />
          </button>
          <small>Quay lại</small>
        </div>
        {step === AVATAR_STEP ? (
          <SetAvatarForm
            avatar={form}
            avatarErrorMsg={formMessage.avatar}
            onSubmitImageForm={handleSubmitImageForm}
            onAvatarInputChange={handleChangeAvatarInput}
          />
        ) : (
          <SetPasswordForm
            form={form}
            passwordValidated={isEnablePasswordSubmitButton}
            passwordErrorMsg={formMessage.password}
            onSubmitPasswordForm={handleSubmitPasswordForm}
            onPasswordFormChange={handleChangePasswordForm}
          />
        )}
      </div>
    </div>
  );
};

export default FirstLogin;
